import React, { useContext, useState } from 'react';
import styles from './SignupLogin.module.css';
import { signInWithEmail } from '../utilities/signInWithEmail';
import { createAccount } from '../utilities/createAccount';
import { useNavigate } from 'react-router-dom';
import { signWithGoogle } from '../utilities/signInWithGoogle';
import { Usercontext } from '../App';

const SignupLogin = () => {

  const navigate  = useNavigate()
  const context = useContext(Usercontext)

  const [isLogin, setIsLogin] = useState(true);
  const [userData, setuserData] = useState({email:"", password:""});
  const [signupData, setSignupData ] = useState({email:"", password:"", displayName:""});

  const handleOnChange = (name,value) => {
    setuserData((prev)=>
      {
        return {...prev,[name]:value}
      })
  }

  const handleOnChangeSignup = (name,value) => {
    setSignupData((prev)=>
      {
        return {...prev,[name]:value}
      })
  }

  const handleSignupWithEmail = async() => {
    const user = await createAccount(signupData)
    if(user)
    {
      context.setuserdata(user)
      navigate('/',{replace : true})

    }
  }

  const handleSlideChange = (event) => {
    setIsLogin(event.target.id === 'login');
  };

  const handleLoginWithEmail = () => {
    signInWithEmail(userData).then((user)=>{
      console.log(user)
      if(user)
      {
        context.setuserdata(user)
        navigate('/',{replace : true})
      }
    });
    // console.log(uid)
  }

  const handleGoogleLogin = async() => {
    // console.log('Google Login Clicked');
    const user = await signWithGoogle()
    if(user)
    {
      context?.setuserdata(user)
      navigate('/',{replace : true})
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleText}>
        <div className={styles.title}>{isLogin ? 'Login' : 'Signup'}</div>
      </div>
      <div className={styles.SignupLogin}>
        <div className={styles.slideControls}>
          <label
            id="login"
            className={isLogin ? styles.active : ''}
            onClick={handleSlideChange}
          >
            Login
          </label>
          <label
            id="signup"
            className={!isLogin ? styles.active : ''}
            onClick={handleSlideChange}
          >
            Signup
          </label>
          <div
            className={styles.sliderTab}
            style={{ left: isLogin ? '0%' : '50%' }}
          ></div>
        </div>
        <div className={styles.formInner}>
          <form className={`${isLogin ? styles.active : ''}`}>
            <div className={styles.field}>
              <input type="text" placeholder="Email Address" name='email' onChange={({target})=>
                {
                  handleOnChange(target.name,target.value)
                }} required />
            </div>
            <div className={styles.field}>
              <input type="password" name="password" placeholder="Password" onChange={({target})=>
                {
                  handleOnChange(target.name,target.value)
                }} required />
            </div>
            <div className={styles.passLink}>
              <a href="#">Forgot password?</a>
            </div>
            <div className={`${styles.field} ${styles.btn}`}>
              <input type="button" value="Login" onClick={handleLoginWithEmail}/>
            </div>
          
          </form>
          {!isLogin? 
          <form className={`${!isLogin ? styles.active : ''}`}>
            <div className={styles.field}>
              <input type="text" placeholder="Name" name='username' onChange={({target})=>
                {
                  handleOnChangeSignup(target.name,target.value)
                }}  required />
            </div>
            <div className={styles.field}>
              <input type="text" placeholder="Email Address" name='email' onChange={({target})=>
                {
                  handleOnChangeSignup(target.name,target.value)
                }}  required />
            </div>
            <div className={styles.field}>
              <input type="password" placeholder="Password" name='password' onChange={({target})=>
                {
                  handleOnChangeSignup(target.name,target.value)
                }}  required />
            </div>
            <div className={`${styles.field} ${styles.btn}`}>
              <input type="button" value="Signup"  onClick={handleSignupWithEmail}/>
            </div>
          </form>
          :null}

          <button 
            type="button" 
            className={styles['login-with-google-btn']}
            onClick={handleGoogleLogin}
          >
            Sign in with Google
          </button>
        </div>``
      </div>
    </div>
  );
};

export default SignupLogin;
